import { Component, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import {Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ConstantService } from '../../../services/constant.service';
import { ApiService } from '../../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-working-days',
  templateUrl: './working-days.component.html'
})
export class WorkingDaysComponent implements OnInit {
  @ViewChild('monthData') public monthData: ModalDirective;
  @ViewChild('deleteProfileModal') public deleteProfileModal: ModalDirective;
  @ViewChild('updateProfileModal') public updateProfileModal: ModalDirective;
  @ViewChild('deleteBulkComplainModal') public deleteBulkComplainModal: ModalDirective;
  public gridApi;
  public gridColumnApi;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  private permission;
  public selectedColony = [];

  public rowSelection;
  _ = _;
  public userTypeList: any = [
    {typeCode: 'admin', permission: 'rwmd'},
    {typeCode: 'staff', permission: 'r'}
  ]
  monthList = [];
  departments = [];
  newMonthData = {
    month: '',
    year: '',
    total_days: 0,
    working_days: 0
  }
  months = this.constantService.MONTHS;
  years = [moment().format('YYYY'), moment().add(1, 'years').format('YYYY'), moment().add(2, 'years').format('YYYY')];
  
  alert = {
    type: 'info',
    msg: '',
    timeout: 5000
  }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  constructor(private profileService: ProfileService, private constantService:  ConstantService, private apiService: ApiService) {
    
    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split('')
    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex:1,
      resizable: true,
      floatingFilter: true,
    };
    this.frameworkComponents = {
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer : DeleteButtonRendererComponent
    };
    
    this.rowSelection = 'multiple';
    
    this.columnDefs = [
      { headerName: 'Srl No', field: 'srl_no', width: 60},
      { headerName: 'Month', field: 'month_text', width: 150 },
      { headerName: 'Year', field: 'year', width: 150 },
      { headerName: 'Total Days', field: 'total_days', width: 150 },
      { headerName: 'Working Days', field: 'working_days', width: 150 }
    ];

    // if (_.includes(permissionArray, 'd')) {
    //   this.columnDefs.push({ headerName: 'Edit', field: 'value', cellRenderer: 'editButtonRenderer', colId: 'params',  width: 60, filter: false, resizable: true, sortable: false, pinned: 'right',cellClass: ['text-center']  },
    //   { headerName: 'Delete', field: 'value', cellRenderer: 'deleteButtonRenderer', colId: 'params1',  width: 60, filter: false, resizable: true, sortable: false, pinned: 'right',cellClass: ['text-center']  },
    //   )
    // }
   }

  ngOnInit(): void {
    
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    // this.departments = this.profileService.getDepartment();
    // console.log(this.departments);
    this.listWorkingDays();
  }
  listWorkingDays() {
    this.apiService.getData('working_days').then((resp: []) => {
      _.each(resp, (item: any) => {
        item['month_text'] = moment().month(parseInt(item.month) - 1).format("MMM");
      })
      this.monthList = resp;
    })
  }
  
  
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  selectedMonth: any = {};
  methodFromParent(userData) {
    this.selectedMonth = userData;
    console.log(this.selectedMonth, userData.action);
    if(userData.action === 'edit') {
      this.newMonthData = _.clone(this.selectedMonth);
      
      this.updateProfileModal.show();
    }
    if(userData.action === 'delete') {
      this.deleteProfileModal.show();
    }
    
    
  }

  saveNewMonthData() {
    // this.newProfileForm.sectors = ((this.selectedItems).map(item => item.item_text)).join(',');

    let duplicateRecord = this.checkForDuplicates(this.newMonthData);
    if(duplicateRecord && duplicateRecord.month) {
      this.alert.type = 'danger';
      this.alert.msg = 'Data already saved for this month';
      setTimeout(() => {
        this.monthData.hide();
      this.alert.type = '';
        this.alert.msg = '';
      }, 2000)
    } else {

      let month_year = this.newMonthData.year + '-' + this.newMonthData.month;
      this.newMonthData['total_days'] = moment(month_year, "YYYY-MM").daysInMonth() ;
      if (this.newMonthData.working_days > this.newMonthData.total_days) {
        this.alert.type = 'danger';
        this.alert.msg = 'working days cannot  exceed total days in month';
        setTimeout(() => {
          this.monthData.hide();
          this.alert.type = '';
          this.alert.msg = '';
        }, 2000)
      } else {
        let that = this;
        this.apiService.addData('working_days', this.newMonthData).subscribe((resp) => {
          console.log(resp);
          that.resetForm();
          that.listWorkingDays();
          that.alert.msg = 'Data has been successfully created.';
          setTimeout(() => {
            that.monthData.hide();
            that.alert.msg = '';
          }, 2000)
        })
      }
      
    }

    
  }

  selectUserType(type) {
    if(type !== 'department') {
    }
  }
  resetForm() {
    this.newMonthData = {
      month: '',
      year: '',
      total_days: 0,
      working_days: 0
    }
    this.selectedColony = [];
  }

  updateProfile() {
    let payload = {
      working_days: this.newMonthData.working_days,
    };
    let that = this;
    this.profileService.updateProfile(this.selectedMonth.srl_no, payload).subscribe((resp) => {
      console.log(resp);
      that.resetForm();
      that.listWorkingDays();
      that.alert.msg = 'Data has been successfully updated.';
      setTimeout(() => {
        that.updateProfileModal.hide();
        that.alert.msg = '';
      }, 2000)
    })
  }

  bulkUpload() {

  }
  onItemSelect(e) {
  }
  onItemDeSelect(e) {
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  checkForDuplicates(data) {
    let filterData = _.filter(this.monthList, (item) => {
      return item.month === data.month && item.year === data.year
    })
    console.log(filterData);
    if (filterData.length > 0) {
      return filterData[0];
    } else {
      return null;
    }
    
  }

}
